import { ReservationStatus } from '@ac/library-api';

export const activeReservationStates = new Set<ReservationStatus>()
  .add(ReservationStatus.IH)
  .add(ReservationStatus.DO)
  .add(ReservationStatus.CO);



// WEBPACK FOOTER //
// ./src/shared/reservations/activeReservationStatuses.ts